<template>
    <div class="animated fadeIn">
        <!-- Statistics Cards -->
            <div class="row mb-4">
                <div class="col-md-4">
                    <div class="stats-card">
                        <div class="stats-label">Total Penempatan</div>
                        <div class="stats-value">{{ formatCurrency(totalPenempatan) }}</div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="stats-card">
                        <div class="stats-label">Total Penarikan</div>
                        <div class="stats-value text-danger">{{ formatCurrency(totalPenarikan) }}</div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="stats-card">
                        <div class="stats-label">Sisa Saldo</div>
                        <div class="stats-value text-success">{{ formatCurrency(sisaSaldo) }}</div>
                    </div>
                </div>
            </div>
            
            <!-- Filter Section -->
            <div class="filter-section">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Tanggal Dari</label>
                            <input type="date" class="form-control" v-model="filterDateFrom">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Tanggal Sampai</label>
                            <input type="date" class="form-control" v-model="filterDateTo">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Sumber Dana</label>
                            <select class="form-control" v-model="filterSumberDana">
                                <option value="">Semua</option>
                                <option value="BCA">BCA</option>
                                <option value="Niaga">Niaga</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="applyFilter">
                            <i class="fas fa-filter mr-1"></i> Terapkan Filter
                        </button>
                        <button class="btn btn-secondary ml-2" @click="resetFilter">
                            <i class="fas fa-redo mr-1"></i> Reset
                        </button>
                        <button class="btn btn-success ml-2" @click="exportToExcel">
                            <i class="fas fa-file-excel mr-1"></i> Export Excel
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Penempatan Dana Murni Finance -->
            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">
                        <i class="fas fa-money-bill-wave mr-2"></i>
                        Penempatan Dana Murni Finance
                    </h5>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Tanggal Penempatan</th>
                                    <th class="text-right">Jumlah Penempatan (Rp)</th>
                                    <th>Sumber Dana</th>
                                    <th>Tanggal Penarikan</th>
                                    <th class="text-right">Jumlah Penarikan (Rp)</th>
                                    <th class="text-right">Sisa Saldo (Rp)</th>
                                    <th class="text-center">Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in penempatanMurni" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ formatDate(item.tanggalPenempatan) }}</td>
                                    <td class="currency text-success font-weight-bold">
                                        {{ formatCurrency(item.jumlahPenempatan) }}
                                    </td>
                                    <td>
                                        <span class="badge badge-info">{{ item.sumberDana }}</span>
                                    </td>
                                    <td>{{ item.tanggalPenarikan ? formatDate(item.tanggalPenarikan) : '-' }}</td>
                                    <td class="currency text-danger font-weight-bold">
                                        {{ item.jumlahPenarikan ? formatCurrency(item.jumlahPenarikan) : '-' }}
                                    </td>
                                    <td class="currency font-weight-bold">
                                        {{ item.sisaSaldo ? formatCurrency(item.sisaSaldo) : '-' }}
                                    </td>
                                    <td class="text-center">
                                        <button class="btn btn-sm btn-primary btn-action" @click="editItem(item)">
                                            <i class="fas fa-edit"></i>
                                        </button>
                                        <button class="btn btn-sm btn-danger btn-action" @click="deleteItem(item)">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="table-primary font-weight-bold">
                                    <td colspan="2">TOTAL</td>
                                    <td class="text-right">{{ formatCurrency(totalPenempatan) }}</td>
                                    <td colspan="2"></td>
                                    <td class="text-right">{{ formatCurrency(totalPenarikan) }}</td>
                                    <td class="text-right">{{ formatCurrency(sisaSaldo) }}</td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <button class="btn btn-success mt-3" @click="showAddModal">
                        <i class="fas fa-plus mr-2"></i> Tambah Data Baru
                    </button>
                </div>
            </div>
            
            <!-- Penempatan Dana DKAB to ABC to APS -->
            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">
                        <i class="fas fa-exchange-alt mr-2"></i>
                        Penempatan Dana DKAB → ABC → APS → MAM
                    </h5>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-hover table-sm">
                            <thead>
                                <tr>
                                    <th rowspan="2">No</th>
                                    <th colspan="3" class="text-center bg-light">DKAB to ABC to APS</th>
                                    <th colspan="3" class="text-center bg-light">APS to MAM</th>
                                    <th colspan="4" class="text-center bg-light">Pengembalian MAM-APS</th>
                                    <th rowspan="2" class="text-center">Aksi</th>
                                </tr>
                                <tr>
                                    <th>Tgl Penempatan</th>
                                    <th class="text-right">Jumlah (Rp)</th>
                                    <th>Bunga (%)</th>
                                    <th class="text-right">Jumlah (Rp)</th>
                                    <th>Bunga (%)</th>
                                    <th>Peruntukan</th>
                                    <th>Tgl Pengembalian</th>
                                    <th class="text-right">Jumlah (Rp)</th>
                                    <th class="text-right">Bunga (Rp)</th>
                                    <th class="text-center">Hari</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in penempatanDKAB" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ formatDate(item.tanggalPenempatan) }}</td>
                                    <td class="currency text-success">{{ formatCurrency(item.jumlahDKAB) }}</td>
                                    <td class="text-center">{{ item.bungaDKAB }}%</td>
                                    <td class="currency text-success">{{ formatCurrency(item.jumlahAPS) }}</td>
                                    <td class="text-center">{{ item.bungaAPS }}%</td>
                                    <td>
                                        <span class="badge badge-primary">{{ item.peruntukan }}</span>
                                    </td>
                                    <td>{{ formatDate(item.tanggalPengembalian) }}</td>
                                    <td class="currency text-info">{{ formatCurrency(item.jumlahPengembalian) }}</td>
                                    <td class="currency text-warning">{{ formatCurrency(item.bungaPengembalian) }}</td>
                                    <td class="text-center">{{ item.jumlahHari }}</td>
                                    <td class="text-center">
                                        <button class="btn btn-sm btn-primary btn-action" @click="editItem(item)">
                                            <i class="fas fa-edit"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
            <!-- Detailed Funding Flow -->
            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">
                        <i class="fas fa-project-diagram mr-2"></i>
                        Detail Alur Dana (DKAB → ABC → APS)
                    </h5>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-hover table-sm">
                            <thead>
                                <tr>
                                    <th rowspan="2">No</th>
                                    <th rowspan="2">Asal Funding</th>
                                    <th rowspan="2">Penyalur</th>
                                    <th rowspan="2">Untuk</th>
                                    <th rowspan="2">Rate</th>
                                    <th rowspan="2" class="text-right">Disbursement</th>
                                    <th rowspan="2">Disb Date</th>
                                    <th rowspan="2">Keterangan</th>
                                    <th colspan="7" class="text-center bg-light">Pengembalian APS → ABC</th>
                                    <th colspan="5" class="text-center bg-warning">Pengembalian ABC → DKAB</th>
                                </tr>
                                <tr>
                                    <th>Tanggal</th>
                                    <th class="text-right">Jumlah</th>
                                    <th>Hari</th>
                                    <th>Bunga %</th>
                                    <th class="text-right">Bunga</th>
                                    <th class="text-right">PPh 15%</th>
                                    <th class="text-right">OS</th>
                                    <th>Tanggal</th>
                                    <th class="text-right">Jumlah</th>
                                    <th>Hari</th>
                                    <th>Bunga %</th>
                                    <th class="text-right">Bunga</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in detailFunding" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td><span class="badge badge-success">{{ item.asalFunding }}</span></td>
                                    <td><span class="badge badge-info">{{ item.penyalur }}</span></td>
                                    <td><span class="badge badge-primary">{{ item.untuk }}</span></td>
                                    <td class="text-center">{{ item.rate }}%</td>
                                    <td class="currency text-success font-weight-bold">
                                        {{ formatCurrency(item.disbursement) }}
                                    </td>
                                    <td>{{ formatDate(item.disbDate) }}</td>
                                    <td><small>{{ item.keterangan }}</small></td>
                                    
                                    <!-- APS to ABC -->
                                    <td>{{ formatDate(item.apsToAbc.tanggal) }}</td>
                                    <td class="currency">{{ formatCurrency(item.apsToAbc.jumlah) }}</td>
                                    <td class="text-center">{{ item.apsToAbc.hari }}</td>
                                    <td class="text-center">{{ item.apsToAbc.bungaPersen }}%</td>
                                    <td class="currency text-warning">{{ formatCurrency(item.apsToAbc.bunga) }}</td>
                                    <td class="currency text-danger">{{ formatCurrency(item.apsToAbc.pph) }}</td>
                                    <td class="currency">{{ formatCurrency(item.apsToAbc.os) }}</td>
                                    
                                    <!-- ABC to DKAB -->
                                    <td>{{ formatDate(item.abcToDkab.tanggal) }}</td>
                                    <td class="currency">{{ formatCurrency(item.abcToDkab.jumlah) }}</td>
                                    <td class="text-center">{{ item.abcToDkab.hari }}</td>
                                    <td class="text-center">{{ item.abcToDkab.bungaPersen }}%</td>
                                    <td class="currency text-warning">{{ formatCurrency(item.abcToDkab.bunga) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
    </div>
</template>

<style lang="scss" scoped>
    body {
            background-color: #f8f9fa;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        
        .header-section {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        
        .card {
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            border: none;
            border-radius: 8px;
            margin-bottom: 2rem;
        }
        
        .card-header {
            background-color: #667eea;
            color: white;
            font-weight: 600;
            border-radius: 8px 8px 0 0 !important;
        }
        
        .table-responsive {
            border-radius: 8px;
        }
        
        .table thead th {
            background-color: #f8f9fa;
            border-bottom: 2px solid #dee2e6;
            font-weight: 600;
            font-size: 0.875rem;
            color: #495057;
            white-space: nowrap;
        }
        
        .table tbody tr:hover {
            background-color: #f1f3f5;
        }
        
        .badge-total {
            font-size: 1rem;
            padding: 0.5rem 1rem;
        }
        
        .currency {
            text-align: right;
            font-family: 'Courier New', monospace;
        }
        
        .section-title {
            color: #495057;
            font-weight: 600;
            margin-bottom: 1rem;
            padding-bottom: 0.5rem;
            border-bottom: 2px solid #667eea;
        }
        
        .stats-card {
            background: white;
            border-radius: 8px;
            padding: 1.5rem;
            margin-bottom: 1rem;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }
        
        .stats-value {
            font-size: 1.5rem;
            font-weight: 700;
            color: #667eea;
        }
        
        .stats-label {
            font-size: 0.875rem;
            color: #6c757d;
            text-transform: uppercase;
        }
        
        .btn-action {
            margin: 0 0.25rem;
        }
        
        .filter-section {
            background: white;
            padding: 1.5rem;
            border-radius: 8px;
            margin-bottom: 1.5rem;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }
</style>


<script>
export default {
  data() {
    return {
                       filterDateFrom: '',
                filterDateTo: '',
                filterSumberDana: '',
                
                // Modal
                modalTitle: 'Tambah Data',
                formData: {
                    tanggalPenempatan: '',
                    jumlahPenempatan: 0,
                    sumberDana: '',
                    tanggalPenarikan: '',
                    jumlahPenarikan: 0
                },
                
                // Data Penempatan Murni Finance
                penempatanMurni: [
                    {
                        tanggalPenempatan: '2022-11-21',
                        jumlahPenempatan: 3000000000,
                        sumberDana: '5260695888 (BCA)',
                        tanggalPenarikan: '2023-02-02',
                        jumlahPenarikan: 100000000000,
                        sisaSaldo: 0
                    },
                    {
                        tanggalPenempatan: '2022-11-22',
                        jumlahPenempatan: 27000000000,
                        sumberDana: '5260695888 (BCA)',
                        tanggalPenarikan: '2023-10-23',
                        jumlahPenarikan: 80000000000,
                        sisaSaldo: 0
                    },
                    {
                        tanggalPenempatan: '2022-11-30',
                        jumlahPenempatan: 60000000000,
                        sumberDana: '706729544900 (Niaga)',
                        tanggalPenarikan: null,
                        jumlahPenarikan: null,
                        sisaSaldo: null
                    },
                    {
                        tanggalPenempatan: '2022-12-07',
                        jumlahPenempatan: 60000000000,
                        sumberDana: '706729544900 (Niaga)',
                        tanggalPenarikan: null,
                        jumlahPenarikan: null,
                        sisaSaldo: null
                    },
                    {
                        tanggalPenempatan: '2022-12-09',
                        jumlahPenempatan: 60000000000,
                        sumberDana: '706729544900 (Niaga)',
                        tanggalPenarikan: null,
                        jumlahPenarikan: null,
                        sisaSaldo: null
                    },
                    {
                        tanggalPenempatan: '2022-12-13',
                        jumlahPenempatan: 20000000000,
                        sumberDana: '706729544900 (Niaga)',
                        tanggalPenarikan: null,
                        jumlahPenarikan: null,
                        sisaSaldo: null
                    }
                ],
                
                // Data Penempatan DKAB
                penempatanDKAB: [
                    {
                        tanggalPenempatan: '2023-02-02',
                        jumlahDKAB: 100000000000,
                        bungaDKAB: 10,
                        jumlahAPS: 100000000000,
                        bungaAPS: 8,
                        peruntukan: 'Gopay Later',
                        tanggalPengembalian: '2023-12-08',
                        jumlahPengembalian: 100000000000,
                        bungaPengembalian: 8333333333,
                        jumlahHari: 309
                    }
                ],
                
                // Data Detail Funding
                detailFunding: [
                    {
                        asalFunding: 'DKAB',
                        penyalur: 'ABC',
                        untuk: 'APS',
                        rate: 8,
                        disbursement: 140000000000,
                        disbDate: '2023-05-31',
                        keterangan: 'Hanya Kelewatan aja (DKAB-ABC-APS)',
                        apsToAbc: {
                            tanggal: '2024-11-28',
                            jumlah: 100000000000,
                            hari: 546,
                            bungaPersen: 10,
                            bunga: 15166666667,
                            pph: 2275000000,
                            os: 40000000000
                        },
                        abcToDkab: {
                            tanggal: '2024-11-28',
                            jumlah: 100000000000,
                            hari: 546,
                            bungaPersen: 8,
                            bunga: 12133333333
                        }
                    }
                ]
    }
  },
  computed: {
                totalPenempatan() {
                    return this.penempatanMurni.reduce((sum, item) => sum + item.jumlahPenempatan, 0);
                },
                
                totalPenarikan() {
                    return this.penempatanMurni.reduce((sum, item) => {
                        return sum + (item.jumlahPenarikan || 0);
                    }, 0);
                },
                
                sisaSaldo() {
                    return this.totalPenempatan - this.totalPenarikan;
                }
            },
            
            methods: {
                formatCurrency(value) {
                    if (!value) return '-';
                    return new Intl.NumberFormat('id-ID', {
                        style: 'currency',
                        currency: 'IDR',
                        minimumFractionDigits: 0
                    }).format(value);
                },
                
                formatDate(dateString) {
                    if (!dateString) return '-';
                    const date = new Date(dateString);
                    return date.toLocaleDateString('id-ID', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                    });
                },
                
                applyFilter() {
                    alert('Filter diterapkan!');
                    // Implementasi logika filter di sini
                },
                
                resetFilter() {
                    this.filterDateFrom = '';
                    this.filterDateTo = '';
                    this.filterSumberDana = '';
                },
                
                exportToExcel() {
                    alert('Export ke Excel!');
                    // Implementasi export ke Excel
                },
                
                showAddModal() {
                    this.modalTitle = 'Tambah Data Baru';
                    this.formData = {
                        tanggalPenempatan: '',
                        jumlahPenempatan: 0,
                        sumberDana: '',
                        tanggalPenarikan: '',
                        jumlahPenarikan: 0
                    };
                    $('#dataModal').modal('show');
                },
                
                editItem(item) {
                    this.modalTitle = 'Edit Data';
                    this.formData = { ...item };
                    $('#dataModal').modal('show');
                },
                
                deleteItem(item) {
                    if (confirm('Yakin ingin menghapus data ini?')) {
                        const index = this.penempatanMurni.indexOf(item);
                        this.penempatanMurni.splice(index, 1);
                        alert('Data berhasil dihapus!');
                    }
                },
                
                saveData() {
                    alert('Data berhasil disimpan!');
                    $('#dataModal').modal('hide');
                    // Implementasi save data
                }
            }
};
</script>
